import { isRunningInJest } from './is-running-in-jest';

interface LogBody {
    level: Level;
    message: string;
    fields: {
        path: string;
        stackTrace?: string;
    };
}

export type Level = 'debug' | 'error' | 'info' | 'warn';

export class Logger {
    public static debug(message: string, fields?: {}) {
        Logger.log('debug', message, fields);
    }

    public static error(message: string, fields?: {}) {
        Logger.log('error', message, fields);
    }

    public static info(message: string, fields?: {}) {
        Logger.log('info', message, fields);
    }

    public static warn(message: string, fields?: {}) {
        Logger.log('warn', message, fields);
    }

    public static log(level: Level, message: string, fields?: {}) {
        if (!isRunningInJest()) {
            const body: LogBody = {
                level,
                message: message || 'No message specified',
                fields: {
                    path: window?.location?.pathname,
                    ...fields,
                },
            };

            if (level === 'error') {
                body.fields.stackTrace = new Error().stack;
            }

            Logger.consoleLog(level, message);

            fetch('/log', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body),
            });
        }
    }

    private static consoleLog(level: Level, message: string) {
        switch (level) {
            case 'debug':
                console.debug(message);
                break;
            case 'error':
                console.error(message);
                break;
            case 'info':
                console.info(message);
                break;
            case 'warn':
                console.warn(message);
                break;
        }
    }
}
